import { useCallback } from 'react';

import { Input, Label, Tooltip } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { TCompanyDetailsDataDE } from './CompanyDetailsDE';
import companyDetailsStyles from './CompanyDetailsDE.module.css';

const TurnoverInputDE = () => {
  const { t } = useLingui();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataDE>();

  const formatCurrency = useCallback(() => {
    const amount = watch('last12MonthsTurnover')?.replace(/[^0-9]+/g, '');
    if (!amount) return '';

    return parseInt(amount).toLocaleString('de-DE');
  }, [watch]);

  return (
    <>
      <div className={companyDetailsStyles.formLabel}>
        <Label htmlFor="last12MonthsTurnover">
          <Trans>Last 12 months’ turnover</Trans>
        </Label>
        <Tooltip
          data-testid="turnover-tooltip"
          content={t`If you have been trading for less than a year, enter your total turnover to date.`}
        />
      </div>
      <Input
        {...register('last12MonthsTurnover')}
        value={formatCurrency()}
        placeholder={t`e.g. 500,000`}
        id={'last12MonthsTurnover'}
        type="text"
        iconRight="euro"
        error={
          errors?.last12MonthsTurnover?.message &&
          errors.last12MonthsTurnover.message
        }
      />
    </>
  );
};

export default TurnoverInputDE;
